import { ISimilarLoadRequest } from "../../schemas/SimilarLoads/SimilarLoads.schema";
import { error } from "./Loads.model";
export const load = {
  loadId: true,
  loadPostingStatus: true,
  sourceSystem: true,
  isHazardous: true,
  isHighValue: true,
  isTemperatureControlled: true,
  totalDistance: true,
  distanceUOM: true,
  totalWeight: true,
  weightUOM: true,
  numberOfStops: true,
  transportMode: true,
  termsAndConditions: true,
  rate: {
    binRateIdentifier: true,
    totalCharge: true,
    lineHaulCharge: {
      charge: true,
      unitCharge: true,
      quantity: true,
      rateQualifier: true,
      chargeDescription: true,
    },
    fuelCharge: {
      charge: true,
      unitCharge: true,
      quantity: true,
      rateQualifier: true,
      chargeDescription: true,
    },
    accessorials: {
      accessorialCode: true,
      accessorialDescription: true,
      accessorialType: true,
      accessorialCharge: {
        charge: true,
        unitCharge: true,
        quantity: true,
        rateQualifier: true,
        chargeDescription: true,
      },
    },
  },
  loadStop: {
    locationName: true,
    addressLine1: true,
    addressLine2: true,
    stopSequence: true,
    stopType: true,
    city: true,
    state: true,
    postalCode: true,
    country: true,
    stopId: true,
    appointmentFrom: true,
    appointmentTo: true,
    timeZone: true,
    deadHead: true,
    specialServices: {
      specialServiceDesc: true,
    },
  },
  buyAllowed: true,
  managedEquipment:true
};
export class SimilarLoadModel implements ISimilarLoadRequest {
  input!:Array<string>;

  getRequestPayload() {
    const input: { [key: string]: any } = {};
    for (const [key, value] of Object.entries(this)) {
      if (typeof value !== "function") input[key] = value;
    }
    return {
      query: {
        recommendedSimilarLoadsByLoadIds : {
          __args: {
            ...input
          },
          loadPostings: {
            ...load,
            managedEquipment: true
          },
          message: true,
          status: true,
          error:error
        },
      },
    };
  }
}
